<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-radio-docs-preview></ui-radio-docs-preview></p>
<h1 id="description">Description</h1>
<p>Radio button</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-selectable-list</span>
    #<span class="hljs-attr">list</span>
    [(<span class="hljs-attr">selected</span>)]=<span class="hljs-string">"selectedOption"</span>
    [<span class="hljs-attr">multiSelect</span>]=<span class="hljs-string">"false"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-radio</span>
        *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let option of radioOptions"</span>
        [<span class="hljs-attr">label</span>]=<span class="hljs-string">"option.label"</span>
        [<span class="hljs-attr">value</span>]=<span class="hljs-string">"option"</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">ui-radio</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-selectable-list</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">public</td>
<td align="left">When true, the input is checked. Useful for setting via e.g. an event to programmatically check the input.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Group id. TODO: Better to call this &quot;name&quot; as in the native implementation</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Unique ID of the component This will be randomised if it is empty</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Label of the radio</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
